export default __webpack_public_path__ + "static/media/videoResourceIcon.1f1786f2.svg";